module.exports = __webpack_public_path__ + "img/bg.8570dfb7.jpg";